import React, { useEffect, useRef } from "react";
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import s from "./KnowMoreAboutDiseases.module.scss";
import ScrollToTop from "../../Components/ScrollToTop/ScrollToTop";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../redux/store";
import { getMoreAboutDiseses } from "../../redux/InformationSlice";
import useWindowDimensions from "../../Components/WindowDimensions/WindowDimensions";
import MobileHeader from "../../Components/MobileHeader/MobileHeader";
import Navigation from "../../Components/Navigation/Navigation";
import { Seo } from "../../Seo";

const KnowMoreAboutDiseases = () => {
  const dispatch: AppDispatch = useDispatch();
  const { width } = useWindowDimensions();
  const diseases = useSelector(
    (state: RootState) => state.info.moreAboutDiseses,
  );
  useEffect(() => {
    dispatch(getMoreAboutDiseses());
  }, []);

  const footerRef = useRef<HTMLDivElement | null>(null);
  const scrollToFooter = () => {
    footerRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div>
      <Seo
        title="Что такое ВИЧ"
        description="Что такое ВИЧ, СПИД, сифилис, туберкулез - информация о заболеваниях для мигрантов"
        url="https://www.vputi.org/about/diseases"
      />
      <div className={s.content}>
        {width > 1100 ? (
          <Header onContactsClick={scrollToFooter} />
        ) : (
          <MobileHeader onContactsClick={scrollToFooter} />
        )}
        <Navigation
          navigation={{
            name: "Главная / Узнай больше о ВИЧ, ТБ и сифилисе",
            path: "/",
          }}
        />
        <div className={s.text}>
          <div className={s.image}>
            <img src={"/images/about_HIVinfo.svg"} className={s.img} />
          </div>
          {Array.isArray(diseases) &&
            [...diseases]?.reverse()?.map((it) => (
              <div className={s.disease_item}>
                <div className={s.icon_wrapper}>
                  <img src={it.image} className={s.icon} />
                </div>

                <div className={s.text_title}>{it?.title_1}</div>
                <div
                  className={s.body}
                  dangerouslySetInnerHTML={{ __html: it?.body_1 ?? "" }}
                ></div>
                <div className={s.title_2}>{it.title_2}</div>
                {it?.body_2 && (
                  <div
                    className={s.yellow_wrapper}
                    dangerouslySetInnerHTML={{ __html: it?.body_2 ?? "" }}
                  ></div>
                )}
                <div
                  className={s.body}
                  dangerouslySetInnerHTML={{ __html: it?.body_3 ?? "" }}
                ></div>
              </div>
            ))}
        </div>
      </div>
      <div ref={footerRef}>
        <Footer />
      </div>
      <ScrollToTop />
    </div>
  );
};

export default KnowMoreAboutDiseases;
